export default {
  product: 'کالا',
  remainingStock: 'موجودی',
    owner: 'مالک',
    productId: 'شناسه کالا',
    productName: 'نام کالا',
    ownerDealerId: 'شناسه مالک',
    ownerName: 'نام مالک',
    statuses: {
    status0: 'رد شده',
    status1: 'موجود',
    status2: 'در حال حمل',
    status3: 'حمل شده',
    status4: 'آرشیو شده'
  }
}
